import { connect } from 'react-redux';
import { Action, Dispatch } from 'redux';
import SocialAccountsPageAP from './SocialAccountsPageAP';
import { NotificationsActions } from '../../app/common/notifications/notificationsActions';

interface StateProps {
    appConfig: {
        SOCIAL_ACCOUNT_MANAGEMENT_ENABLED: boolean;
        CHALLENGER_PID: string;
    };
}

interface DispatchProps {
    showSuccessNotification: (message: string) => void;
    showErrorNotification: (message: string) => void;
}

function mapStateToProps(state: any): StateProps {
    return {
        appConfig: {
            SOCIAL_ACCOUNT_MANAGEMENT_ENABLED:
                state.app.appConfig.SOCIAL_ACCOUNT_MANAGEMENT_ENABLED,
            CHALLENGER_PID: state.app.appConfig.CHALLENGER_ENABLED
                ? state.app.appConfig.CHALLENGER_PIDS.LINKED_SERVICES_ACCOUNTS_AP ?? ''
                : '',
        },
    };
}

function mapDispatchToProps(dispatch: Dispatch<Action>): DispatchProps {
    return {
        showSuccessNotification: (message: string) => {
            dispatch(NotificationsActions.showSuccess(message));
        },
        showErrorNotification: (message: string) => {
            dispatch(NotificationsActions.showError(message));
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SocialAccountsPageAP);
